module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/rack-server/rack.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/rack-server/rack.png
// module id = 608
// module chunks = 0